import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { Observable, throwError, of } from 'rxjs';
import { BaseService } from '../base/base-service';
import { FrontendUrl, Tenant } from '../models/tenant';

@Injectable({
  providedIn: 'root'
})
export class TenantService extends BaseService {
  readonly uris = {
    tenant: `tenant`,
  
  };

  init() {}

  getBaseUrl(request: FrontendUrl): Observable<Tenant> {
    return this.http.post<Tenant>(this.getInitUrl(this.uris.tenant, false),request).pipe(
      catchError(err => {
        return this.cacheHandler(err, 'tenant');
      })
    );
  } 

  get(): Observable<Tenant> {
    return this.http.get<Tenant>(this.getUrl(this.uris.tenant, false)).pipe(
      catchError(err => {
        return this.cacheHandler(err, 'tenant');
      })
    );
  }
  
}
